import React, { useState, useEffect, useRef } from "react";
import "./UpiFlow.css";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../../common/Navbar";
import axios from "axios";
import * as Constants from "../../../../../Constants/index";
import swal from "sweetalert";
import CircleLoade from "../../../loader/CircleLoade";

const UpiFlow = () => {
  // 9438264585@ybl  upi id testing
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [currentFlow, setCurrentFlow] = useState("verify");
  const [verifiedUpi, setVerifiedUpi] = useState("");
  const [conversionRate, setConversionRate] = useState(1);  
  const [pendingPoints, setPendingPoints] = useState(null);
  const [otpCode, setOtpCode] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");
  const [vpaInput, setVpaInput] = useState("");
  const [vpaError, setVpaError] = useState(false);
  const [pointsError, setPointsError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState("enter"); // 'enter', 'validating', 'error', 'success'
  const [showUpiSheet, setShowUpiSheet] = useState(false);
  const [changeUpiInput, setChangeUpiInput] = useState("");
  const token = localStorage.getItem("token");
  const user_name = localStorage.getItem("user_name");
  const [btnLoader, setBtnLoader] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const otpBlockRef = useRef(null);
  const [ammount, setAmmount] = useState(false);
  const [showOtpData, setShowOtpData] = useState(false);
  const [verifyUpiId, setVerifyUpiId] = useState(false);
  const [selecteVerifyUpi, setSelecteVerifyUpi] = useState("");

  // Helpers
  const validVPA = (v) => /^[A-Za-z0-9._-]{2,}@[A-Za-z]{2,}$/.test(v);
  const toINR = (n) => "₹ " + Number(n || 0).toLocaleString("en-IN");

  // Get fresh values from localStorage each time they're needed
  const getUserPoints = () => parseInt(localStorage.getItem("user_points") || "0", 10);
  const getFirmName = () => localStorage.getItem("firmName") || "";
  const getMerchantId = () => localStorage.getItem("merchantId") || "";
  const getPanNumber = () => localStorage.getItem("panNumber") || "";
  const getGstNumber = () => localStorage.getItem("gst") || "";
  const getUpiMobile = () => localStorage.getItem("UpiMobile") || "";
  const getUserName = () => localStorage.getItem("userName") || "";
  const getFuzzyPercentage = () => localStorage.getItem("fuzzy_match_percentage") || "";
  const getOutputId = () => localStorage.getItem("outputId") || "";
  const getUpiAmount = () => localStorage.getItem("upiAmount") || "";
  const getRedeemPoints = () => localStorage.getItem("redeempoints") || "";
  const getUpiStatus = () => localStorage.getItem("upiStatus") || "";
  const getUserOutputId = () => localStorage.getItem("userOrderId") || "";
  const getProgramId = () => localStorage.getItem("program_id") || Constants.program2;

  // State mirrored from localStorage
  const [availablePoints, setAvailablePoints] = useState(getUserPoints());
  const [firmName, setFirmName] = useState(getFirmName());
  const [merchantId, setMerchantId] = useState(getMerchantId());
  const [panNumber, setPanNumber] = useState(getPanNumber());
  const [gstNumber, setGstNumber] = useState(getGstNumber());
  const [UpiMobile, setUpiMobile] = useState(getUpiMobile());
  const [userName, setUserName] = useState(getUserName());
  const [fuzzy_percentage, setFuzzyPercentage] = useState(getFuzzyPercentage());
  const [outputId, setOutputId] = useState(getOutputId());
  const [user_Order_Id, setUser_Order_Id] = useState(getUserOutputId());

  // Scroll into view when otpCode becomes true and OTP block exists
  useEffect(() => {
    if (otpCode && otpBlockRef.current) {
      setTimeout(() => {
        otpBlockRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 80);
    }
  }, [otpCode, showOtpData]);

  // Step management
  useEffect(() => {
    getUserDetails();
    if (currentFlow === "verify") setCurrentStep(1);
    else if (currentFlow === "details") setCurrentStep(2);
    else if (currentFlow === "redeem") setCurrentStep(3);
    else if (currentFlow === "success") setCurrentStep(5);
  }, [currentFlow]);

  const getUserDetails = async () => {
    const tokenLocal = localStorage.getItem("token");
    try {
      const res = await axios.post(
        Constants.baseUrl + "auth/profile/get",
        {},
        {
          headers: {
            Authorization: `Bearer ${tokenLocal}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
        }
      );
      if (res.data.result === "success") {
        const bankingD = res.data.output?.bankDetail?.upiVerify || false;
        const userCurrentId = res.data.output?.bankDetail?.upiId || "";

        // store safely as strings
        localStorage.setItem("user_points", String(res.data.output?.points || 0));
        localStorage.setItem("firmName", res.data.output?.firmName || "");
        localStorage.setItem("merchantId", res.data.output?.merchantId || "");
        localStorage.setItem("gst", res.data.output?.userModelKYC?.gst || "");
        localStorage.setItem("userName", res.data.output?.name || "");
        localStorage.setItem("panNumber", res.data.output?.userModelKYC?.panNumber || "");
        localStorage.setItem("UpiMobile", res.data.output?.mobile || "");

        // update local state copies
        setVerifyUpiId(Boolean(bankingD));
        setSelecteVerifyUpi(userCurrentId || "");
        // If backend says upiVerify true, set both verifiedUpi and vpaInput
        if (bankingD === true && userCurrentId) {
          setVpaInput(userCurrentId);
          setVerifiedUpi(userCurrentId);
        }

        // Update state with fresh values from localStorage (ensures consistency)
        setAvailablePoints(getUserPoints());
        setFirmName(getFirmName());
        setMerchantId(getMerchantId());
        setGstNumber(getGstNumber());
        setUserName(getUserName());
        setPanNumber(getPanNumber());
        setUpiMobile(getUpiMobile());
      }
    } catch (error) {
      console.log("getUserDetails error:", error);
    }
  };

  // UPI Validation
  const handleValidateUpi = async () => {
    setBtnLoader(true);
    setVerificationStatus("enter"); // reset intermediate state
    setVpaError(false);

    const cleanVpa = (vpaInput || "").trim().toLowerCase();

    if (!validVPA(cleanVpa)) {
      setVpaError(true);
      setBtnLoader(false);
      return;
    }

    // If already verified on profile and same ID, just proceed
    if (verifyUpiId === true && cleanVpa === (selecteVerifyUpi || "").toLowerCase()) {
      // ensure verifiedUpi is set
      setVerifiedUpi(cleanVpa);
      setVpaInput(cleanVpa);
      setVerificationStatus("success");
      setBtnLoader(false);
      setCurrentFlow("details");
      return;
    }

    setVerificationStatus("validating");
    setIsVerifying(true);

    try {
      const res = await axios.post(
        Constants.baseUrl + "payment/verify/vpa",
        { vpa: cleanVpa, merchantId: merchantId, name: userName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: getProgramId(),
          },
        }
      );

      const data = res?.data?.output?.data;

      if (data && data.status === "success" && data.is_valid === true) {
        // save fuzzy percentage and mark verified
        localStorage.setItem(
          "fuzzy_match_percentage",
          String(data.fuzzy_match_percentage || "")
        );
        setFuzzyPercentage(getFuzzyPercentage());
        // update store/profile
        await getUserDetails();
        setVerifiedUpi(cleanVpa);
        setVpaInput(cleanVpa);
        setVerificationStatus("success");
      } else {
        setVerificationStatus("error");
        setVpaError(true);
      }
    } catch (error) {
      console.log("handleValidateUpi error:", error);
      setVerificationStatus("error");
      setVpaError(true);
    } finally {
      setBtnLoader(false);
      setIsVerifying(false);
    }
  };

  const handleTryAgain = () => {
    setVerificationStatus("enter");
    setVpaError(false);
    setBtnLoader(false);
  };

  const handleCancelVerification = () => {
    setVerificationStatus("enter");
    setBtnLoader(false);
  };

  // Proceed to details
  const handleGoToDetails = () => {
    // ensure verifiedUpi is set
    if (!verifiedUpi && vpaInput) setVerifiedUpi(vpaInput);
    setCurrentFlow("details");
  };

  // Proceed to redemption
  const handleGoToRedeem = () => {
    setCurrentFlow("redeem");
  };

  // Points input handler
  const handlePointsChange = (e) => {
    const raw = e.target.value;
    // allow empty to let user clear
    if (raw === "") {
      setPendingPoints(0);
      setPointsError(true);
      return;
    }
    const value = parseInt(raw, 10) || 0;
    setPendingPoints(value);
    const valid = value >= 1 && value <= availablePoints && Number.isInteger(value);
    setPointsError(!valid);
  };

  // Generate OTP
  const handleGenerateOtp = async () => {
    // ensure we have a verified UPI
    if (!verifiedUpi && vpaInput) {
      // If user entered a vpa but didn't validate, disallow
      swal("Error", "Please validate your UPI ID before generating OTP.", "error");
      return;
    }

    if (pointsError || pendingPoints === 0) {
      swal("Error", "Enter between 1 and your available points.", "error");
      return;
    }

    setBtnLoader(true);
    try {
      const res = await axios.post(
        Constants.baseUrl + "redeem/bank/request/program2",
        {
          bankType: "UPI",
          points: pendingPoints,
          requestId: "",
          otp: "",
          upiId: verifiedUpi || vpaInput,
          // percentage: fuzzy_percentage,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: getProgramId(),
          },
        }
      );

      if (res.data.code === 10001) {
        localStorage.setItem("outputId", String(res.data.output?.upiOrderId || ""));
        setOutputId(getOutputId());
        setAmmount(true);
        swal("Success", res.data.msg || "OTP sent", "success");
        setShowOtpData(true);
        setOtpCode(true);

        // scroll into view after a short delay
        setTimeout(() => {
          if (otpBlockRef.current) {
            otpBlockRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 120);
      } else {
        setShowOtpData(false);
        setOtpCode(false);
        swal("Error", res.data.msg || "Unable to generate OTP", "error");
      }
    } catch (error) {
      console.log("handleGenerateOtp error:", error);
      swal("Error", "Something went wrong while requesting OTP.", "error");
    } finally {
      setBtnLoader(false);
    }
  };

  // Resend OTP
  const handleResendOtp = async () => {
    setBtnLoader(true);
    try {
      const res = await axios.post(
        Constants.baseUrl + "redeem/bank/request/program2",
        {
          bankType: "UPI",
          points: pendingPoints,
          requestId: "",
          otp: "",
          upiId: verifiedUpi || vpaInput,
          // percentage: fuzzy_percentage,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: getProgramId(),
          },
        }
      );

      if (res.data.code === 10001) {
        localStorage.setItem("outputId", String(res.data.output?.upiOrderId || ""));
        setOutputId(getOutputId());
        swal("Success", res.data.msg || "OTP resent", "success");
        setShowOtpData(true);
        setOtpCode(true);
        setTimeout(() => {
          if (otpBlockRef.current) {
            otpBlockRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 120);
      } else {
        setShowOtpData(false);
        swal("Error", res.data.msg || "Unable to resend OTP", "error");
      }
    } catch (error) {
      console.log("handleResendOtp error:", error);
      swal("Error", "Something went wrong while resending OTP.", "error");
    } finally {
      setBtnLoader(false);
    }
  };

  const handleConfirmRedemption = async () => {
    setIsConfirming(true);
    setBtnLoader(true);
    setOtpError(false);

    // basic validation
    if (!enteredOtp || enteredOtp.length !== 6) {
      setOtpError(true);
      setBtnLoader(false);
      setIsConfirming(false);
      return;
    }

    const payload = {
      bankType: "UPI",
      points: pendingPoints,
      requestId: outputId || getOutputId(),
      otp: enteredOtp,
      upiId: verifiedUpi || vpaInput,
      // percentage: fuzzy_percentage,
    };

    try {
      const res = await axios.post(
        Constants.baseUrl + "redeem/bank/request/program2",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: getProgramId(),
          },
        }
      );
      if (res.data.code === 10001) {
        localStorage.setItem("upiAmount", String(res.data.output?.upiAmount || ""));
        localStorage.setItem("redeempoints", String(res.data.output?.points || ""));
        localStorage.setItem("upiStatus", String(res.data.output?.upiStatus || ""));
        localStorage.setItem("userOrderId", String(res.data.output?.id || ""));
        setCurrentFlow("success");
      } else {
        setOtpError(true);
        swal("Error", res.data.msg || "Invalid OTP or request failed", "error");
      }
    } catch (error) {
      console.log("handleConfirmRedemption error:", error);
      swal("Error", "Something went wrong while confirming redemption.", "error");
      setOtpError(true);
    } finally {
      setBtnLoader(false);
      setIsConfirming(false);
    }
  };

  // Change UPI
  const handleSaveChangedUpi = () => {
    if (!validVPA(changeUpiInput)) {
      alert("Please enter a valid UPI ID");
      return;
    }
    setVerifiedUpi(changeUpiInput.trim().toLowerCase());
    setShowUpiSheet(false);
    alert("UPI verified & updated");
  };

  const openUpiSheet = () => {
    setChangeUpiInput(verifiedUpi || vpaInput);
    setShowUpiSheet(true);
  };

  // Render methods for different flows
  const renderStepper = () => (
    <div className="upi-flow-wrap">
      <div className="upi-flow-stepper" aria-label="Progress">
        {[1, 2, 3, 4, 5].map((step) => (
          <div
            key={step}
            className={`upi-flow-step ${currentStep === step ? "active" : ""} ${
              currentStep > step ? "ok" : ""
            }`}
          >
            <div className="upi-flow-num">{step}</div>
            <span>
              {step === 1 && "UPI Verify"}
              {step === 2 && "Details"}
              {step === 3 && "Redemption"}
              {step === 4 && "OTP"}
              {step === 5 && "Done"}
            </span>
          </div>
        ))}
      </div>
      <div className="upi-flow-brandbar"></div>
    </div>
  );

  const renderVerifyFlow = () => {
    // Validating State
    if (verificationStatus === "validating") {
      return (
        <section
          className="upi-flow-stage"
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <h1>Validating your UPI ID…</h1>
          <p className="upi-flow-sub">
            Please wait while we verify it with the UPI network
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "6px",
            }}
          >
            <div className="upi-flow-loader" aria-hidden="true"></div>
            <div>Contacting VPA verifier…</div>
          </div>
          <div style={{ marginTop: "12px" }}>
            <span className="upi-flow-mutedbox">
              UPI ID: <strong>{verifiedUpi || vpaInput}</strong>
            </span>
          </div>
          <div className="upi-flow-row" style={{ justifyContent: "flex-end" }}>
            <button
              className="upi-flow-btn upi-flow-light"
              onClick={handleCancelVerification}
              disabled={btnLoader}
            >
              Cancel
            </button>
          </div>
        </section>
      );
    }

    // Error State
    if (verificationStatus === "error") {
      return (
        <section className="upi-flow-stage" aria-labelledby="err-title">
          <div className="upi-flow-result upi-flow-err">
            <div
              className="upi-flow-icon"
              style={{
                color: "white",
                fontSize: "25px",
                fontWeight: "700",
                background: "#b00020",
              }}
            >
              ✕
            </div>
            <h1
              id="err-title"
              style={{ margin: "6px 0 0", color: "var(--upi-error)" }}
            >
              The UPI name does not sufficiently match the registered profile.
            </h1>
            <p className="upi-flow-sub">Please check your UPI ID and try again</p>
          </div>
          <div className="upi-flow-row" style={{ justifyContent: "center" }}>
            <button
              className="upi-flow-btn upi-flow-ghost"
              onClick={handleTryAgain}
              disabled={btnLoader}
            >
              Try Again
            </button>
          </div>
        </section>
      );
    }

    // Success State
    if (verificationStatus === "success") {
      return (
        <section className="upi-flow-stage" aria-labelledby="ok-title">
          <div className="upi-flow-result upi-flow-ok">
            <div
              className="upi-flow-icon"
              style={{ color: "white", fontSize: "25px", fontWeight: "700" }}
            >
              ✓
            </div>
            <h1 id="ok-title" style={{ margin: "6px 0 0" }}>
              UPI ID Verified Successfully
            </h1>
            <p className="upi-flow-sub">Your UPI ID is valid and registered</p>
            <p className="upi-flow-mutedbox">
              UPI ID: <strong>{verifiedUpi || selecteVerifyUpi || vpaInput}</strong>
            </p>
          </div>
          <div className="upi-flow-row" style={{ justifyContent: "center" }}>
            <button
              className="upi-flow-btn upi-flow-primary"
              onClick={handleGoToDetails}
              disabled={btnLoader}
            >
              Continue
            </button>
          </div>
        </section>
      );
    }

    // Default Enter State
    return (
      <section className="upi-flow-stage" aria-labelledby="enter-title">
        <h1 id="enter-title">Enter UPI ID</h1>
        <p className="upi-flow-sub">Please enter your UPI ID to continue</p>
        <div className="upi-flow-field">
          <div className="upi-flow-label">UPI ID</div>
          <div className="upi-flow-control">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M4 12h16M4 6h16M4 18h10" stroke="currentColor" />
            </svg>
            <input
              id="vpa"
              type="text"
              inputMode="email"
              placeholder="username@bank"
              value={vpaInput}
              onChange={(e) => {
                const cleanValue = e.target.value.replace(/\s/g, "").toLowerCase();
                setVpaInput(cleanValue);
                setBtnLoader(false);
                setVpaError(false);
                setVerificationStatus("enter");
              }}
            />
          </div>
          <div className="upi-flow-hint">
            Examples: name@paytm, user@phonepe, id@oksbi
          </div>
          {vpaError && (
            <div className="upi-flow-hint upi-flow-err">Enter a valid UPI ID</div>
          )}
        </div>
        <div className="upi-flow-row">
          <button
            className="upi-flow-btn upi-flow-primary"
            onClick={handleValidateUpi}
            disabled={btnLoader || isVerifying}
          >
            {btnLoader || isVerifying ? "Validating…" : "Validate UPI ID"}
          </button>
        </div>
      </section>
    );
  };

  const renderDetailsFlow = () => (
    <div className="upi-flow-grid">
      <section className="upi-flow-card">
        <h3>UPI Transfer Details</h3>

        <div className="upi-flow-field">
          <div className="upi-flow-label">Firm Name</div>
          <div className="upi-flow-control">
            <span>{firmName && firmName !== "null" ? firmName : ""}</span>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%", gap: "20px" }}>
          <div className="upi-flow-field">
            <div className="upi-flow-label">Owner Name</div>
            <div className="upi-flow-control2">
              <span>{user_name && user_name !== "null" ? user_name : ""}</span>
            </div>
          </div>
          <div className="upi-flow-field">
            <div className="upi-flow-label">Bizom ID / RT-Code</div>
            <div className="upi-flow-control2">
              <span>{merchantId && merchantId !== "null" ? merchantId : ""}</span>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%", gap: "20px" }}>
          <div className="upi-flow-field">
            <div className="upi-flow-label">Mobile Number</div>
            <div className="upi-flow-control2">
              <span>{UpiMobile && UpiMobile !== "null" ? UpiMobile : ""}</span>
            </div>
          </div>
          <div className="upi-flow-field">
            <div className="upi-flow-label">PAN Number</div>
            <div className="upi-flow-control2 upi-flow-readonly">
              <span>{panNumber && panNumber !== "null" ? panNumber : ""}</span>
            </div>
          </div>
        </div>

        <div className="upi-flow-field">
          <div className="upi-flow-label">GST Number</div>
          <div className="upi-flow-control upi-flow-readonly">
            <span>{gstNumber && gstNumber !== "null" ? gstNumber : ""}</span>
          </div>
          <div className="upi-flow-hint">Masked for your security.</div>
        </div>
        <div className="upi-flow-field">
          <div className="upi-flow-label">UPI ID</div>
          <div className="upi-flow-control upi-flow-readonly">
            <span>{verifiedUpi || vpaInput}</span>
            <span className="upi-flow-badge" style={{ marginLeft: "auto" }}>
              ✓ Verified
            </span>
          </div>
        </div>

        <div className="upi-flow-row" style={{ justifyContent: "flex-end" }}>
          <button
            className="upi-flow-btn upi-flow-primary"
            onClick={handleGoToRedeem}
            disabled={btnLoader}
          >
            Proceed to Redemption →
          </button>
        </div>
      </section>

      <aside className="upi-flow-summary">
        <div className="upi-flow-card">
          <h3>Payout Summary</h3>
          <div className="upi-flow-rows">
            <div className="upi-flow-rowline upi-flow-muted">
              <span>Available Points</span>
              <span>{availablePoints.toLocaleString("en-IN")}</span>
            </div>
            <div className="upi-flow-rowline upi-flow-muted">
              <span>Conversion</span>
              <span>₹ {conversionRate} / point</span>
            </div>
          </div>
          <div className="upi-flow-total">
            <span>Net Transfer</span>
            <b>{toINR(availablePoints * conversionRate)}</b>
          </div>
          <div className="upi-flow-rows">
            <div className="upi-flow-rowline">
              <span>To</span>
              <span>{selecteVerifyUpi || verifiedUpi || vpaInput}</span>
            </div>
            <div className="upi-flow-rowline">
              <span>Name</span>
              <span>{user_name}</span>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );

  const renderRedeemFlow = () => (
    <div className="upi-flow-grid">
      <section className="upi-flow-card">
        <h3>UPI Redemption</h3>

        <div
          className="upi-flow-rows"
          style={{
            gridTemplateColumns: "repeat(2,1fr)",
            gap: "12px",
            marginBottom: "10px",
          }}
        >
          <div className="upi-flow-card" style={{ padding: "14px" }}>
            <div className="upi-flow-label">Points Available</div>
            <div style={{ fontSize: "22px", fontWeight: "800" }}>
              {availablePoints.toLocaleString("en-IN")}
            </div>
          </div>
          <div className="upi-flow-card" style={{ padding: "14px" }}>
            <div className="upi-flow-label">Redeemable Value</div>
            <div style={{ fontSize: "22px", fontWeight: "800" }}>
              {toINR(availablePoints * conversionRate)}
            </div>
          </div>
        </div>

        <div className="upi-flow-field">
          <div className="upi-flow-label">Enter Points</div>
          <div className="upi-flow-control">
            <input
              type="number"
              min="1"
              step="1"
              placeholder="Enter points to redeem"
              onChange={handlePointsChange}
              value={pendingPoints}
              className="no-spinner"
              disabled={ammount}
            />
          </div>
          {pointsError && (
            <div className="upi-flow-hint upi-flow-err">
              Enter between 1 and your available points.
            </div>
          )}
        </div>

        <div className="upi-flow-field">
          <div className="upi-flow-label">Point Value in INR</div>
          <div className="upi-flow-control upi-flow-readonly">
            <span>{toINR(Math.max(0, pendingPoints * conversionRate))}</span>
          </div>
        </div>

        <div className="upi-flow-field">
          <div className="upi-flow-label">UPI ID</div>
          <div className="upi-flow-control upi-flow-readonly">
            <span>{verifiedUpi || vpaInput}</span>
            <span className="upi-flow-badge" style={{ marginLeft: "auto" }}>
              ✓ Verified
            </span>
          </div>
        </div>

        <div
          className="upi-flow-row"
          style={{ justifyContent: "flex-end", gap: "10px" }}
        >
          <button
            className="upi-flow-btn upi-flow-light"
            onClick={handleGenerateOtp}
            disabled={btnLoader || ammount}
          >
            {btnLoader ? "Processing…" : "Generate OTP"}
          </button>
        </div>

        {showOtpData && otpCode && (
          <div id="otp-block" ref={otpBlockRef}>
            <div className="upi-flow-field">
              <div className="upi-flow-label">Enter OTP</div>
              <div className="upi-flow-control">
                <input
                  type="text"
                  maxLength="6"
                  placeholder="Enter 6-digit OTP"
                  inputMode="numeric"
                  value={enteredOtp}
                  onChange={(e) => {
                    // allow only digits
                    const val = e.target.value.replace(/\D/g, "");
                    setEnteredOtp(val);
                    if (otpError) setOtpError(false);
                  }}
                />
              </div>
              <div className="upi-flow-hint">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleResendOtp();
                  }}
                >
                  Resend OTP
                </a>
              </div>
              {otpError && (
                <div className="upi-flow-hint upi-flow-err">Invalid OTP.</div>
              )}
            </div>
            <div
              className="upi-flow-row"
              style={{ justifyContent: "flex-end" }}
            >
              <button
                className="upi-flow-btn upi-flow-primary"
                onClick={handleConfirmRedemption}
                disabled={enteredOtp.length !== 6 || btnLoader}
              >
                {isConfirming || btnLoader ? "Confirming…" : "Confirm Request"}
              </button>
            </div>
          </div>
        )}
      </section>

      <aside className="upi-flow-summary">
        <div className="upi-flow-card">
          <h3>Summary</h3>
          <div className="upi-flow-rows">
            <div className="upi-flow-rowline upi-flow-muted">
              <span>Points to Redeem</span>
              <span>
                {!pointsError && pendingPoints > 0
                  ? pendingPoints.toLocaleString("en-IN")
                  : "0"}
              </span>
            </div>
            <div className="upi-flow-rowline upi-flow-muted">
              <span>Conversion</span>
              <span>₹ {conversionRate} / point</span>
            </div>
          </div>
          <div className="upi-flow-total">
            <span>Amount</span>
            <b>
              {!pointsError && pendingPoints > 0
                ? toINR(pendingPoints * conversionRate)
                : "₹ 0"}
            </b>
          </div>
          <div className="upi-flow-rows">
            <div className="upi-flow-rowline">
              <span>UPI</span>
              <span>{verifiedUpi || vpaInput}</span>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );

  const renderSuccessFlow = () => (
    <section className="upi-flow-stage">
      <div className="upi-flow-result upi-flow-ok">
        <div
          className="upi-flow-icon"
          style={{ color: "white", fontSize: "25px", fontWeight: "700" }}
        >
          ✓
        </div>
        <h1>Request Submitted Successfully</h1>
        <p className="upi-flow-sub">
          Your redemption request will be processed shortly.
        </p>
      </div>
      <div
        className="upi-flow-card"
        style={{ maxWidth: "520px", margin: "16px auto 0" }}
      >
        <div className="upi-flow-rowline">
          <strong>Order Id</strong>
          <strong>{getUserOutputId()}</strong>
        </div>
        <div className="upi-flow-rowline">
          <strong>Points Redeemed</strong>
          <strong>{getRedeemPoints()}</strong>
        </div>
        <div className="upi-flow-rowline" style={{ marginTop: "6px" }}>
          <strong>Amount</strong>
          <strong>{toINR(getUpiAmount())}</strong>
        </div>
        <div className="upi-flow-rowline" style={{ marginTop: "6px" }}>
          <strong>Status</strong>
          <strong>{getUpiStatus()}</strong>
        </div>
      </div>
      <div
        className="upi-flow-row"
        style={{ justifyContent: "center", marginTop: "16px" }}
      >
        <button
          className="upi-flow-btn upi-flow-primary"
          onClick={() => {
            navigate("/retailer_Dashboard");
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </section>
  );

  return (
    <>
      <Navbar />
      {isConfirming && (
        <div className="upi-flow-loader-overlay">
          <CircleLoade />
        </div>
      )}
      <div className="upi-flow-app">
        {renderStepper()}

        <div className="upi-flow-wrap">
          {currentFlow === "verify" && renderVerifyFlow()}
        </div>

        <div
          className={`upi-flow-wrap ${
            currentFlow !== "details" ? "upi-flow-hide" : ""
          }`}
        >
          {currentFlow === "details" && renderDetailsFlow()}
        </div>

        <div
          className={`upi-flow-wrap ${
            currentFlow !== "redeem" ? "upi-flow-hide" : ""
          }`}
        >
          {currentFlow === "redeem" && renderRedeemFlow()}
        </div>

        <div
          className={`upi-flow-wrap ${
            currentFlow !== "success" ? "upi-flow-hide" : ""
          }`}
        >
          {currentFlow === "success" && renderSuccessFlow()}
        </div>

        {/* Change UPI Modal */}
        {showUpiSheet && (
          <div className="upi-flow-sheet-overlay">
            <div className="upi-flow-sheet-content">
              <h3 style={{ margin: "0 0 10px" }}>Change UPI</h3>
              <div className="upi-flow-field">
                <div className="upi-flow-label">UPI ID</div>
                <div className="upi-flow-control">
                  <input
                    type="text"
                    placeholder="name@bank"
                    inputMode="email"
                    value={changeUpiInput}
                    onChange={(e) => setChangeUpiInput(e.target.value)}
                  />
                </div>
                <div className="upi-flow-hint">
                  Enter a valid handle like <b>name@bank</b>.
                </div>
              </div>
              <div
                className="upi-flow-row"
                style={{ justifyContent: "flex-end" }}
              >
                <button
                  className="upi-flow-btn upi-flow-light"
                  onClick={() => setShowUpiSheet(false)}
                >
                  Cancel
                </button>
                <button
                  className="upi-flow-btn upi-flow-primary"
                  onClick={handleSaveChangedUpi}
                >
                  Save & Verify
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UpiFlow;
